import React, { useEffect, useState, useCallback } from 'react';
import {
  Container,
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
  Tooltip,
  Chip,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Avatar,
  Badge,
  Divider,
  InputAdornment,
  Fade,
  useTheme,
  Alert,
  Snackbar,
  MenuItem,
  Select,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import {
  Search as SearchIcon,
  FilterList as FilterListIcon,
  Clear as ClearIcon,
  Visibility as VisibilityIcon,
  AccessAlarm as AccessAlarmIcon,
  TrendingUp as TrendingUpIcon,
  AttachMoney as AttachMoneyIcon,
  People as PeopleIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  Refresh as RefreshIcon,
  Warning as WarningIcon,
  ArrowBackIos as ArrowBackIosIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
} from '@mui/icons-material';

// Import Actions
import { LeadsDoneDealOnly_Action } from '../Redux/Actions/Accountant_Action';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import DoneDealQuickFilterModal from './DoneDealQuickFilterModal';

export const AccountantPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const mode = theme.palette.mode;

  // State declarations
  const [userlogin, setuserlogin] = useState(null);
  const [searchword, setSearchword] = useState(
    localStorage.getItem('searchAccountantuserstorage') || '',
  );
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [activeFilters, setActiveFilters] = useState(0);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    stage: [],
    project: [],
    developer: [],
    chanel: [],
    campaign: [],
    sales: [], // أضف هذا

    createdAt: { from: null, to: null },
    stagedateupdated: { from: null, to: null },
  });
  const [error, setError] = useState(null);
  const [localSearchMode, setLocalSearchMode] = useState(false);

  // Get user data from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        setuserlogin(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing user data:', error);
      }
    }
  }, []);

  // 🔥 دالة لبناء الـ query string من الفلاتر
  const buildQueryString = useCallback(
    (page = null, filters = appliedFilters) => {
      const pageToUse = page !== null ? page : currentPage;

      // 🔥 بناء الـ query string يدوياً
      let queryString = `page=${pageToUse + 1}&limit=${rowsPerPage}`;

      // إضافة البحث
      if (searchword && searchword.trim() !== '') {
        // معالجة البحث
        let processedSearchTerm = searchword;
        if (searchword.includes('+')) {
          processedSearchTerm = searchword.replace('+', '');
        }
        queryString += `&keyword=${encodeURIComponent(processedSearchTerm.trim())}`;
      }

      // 🔥 إضافة الفلاتر
      console.log('🎯 Processing filters in buildQueryString:', filters);

      // دالة مساعدة للحصول على ID العنصر
      const getItemId = (item) => {
        return item?._id || item?.id || item?.name || JSON.stringify(item);
      };

      // معالجة Stage filters
      if (filters.stage && filters.stage.length > 0) {
        filters.stage.forEach((stage) => {
          const itemId = getItemId(stage);
          if (itemId) {
            queryString += `&stage=${encodeURIComponent(itemId)}`;
          }
        });
      }

      // معالجة Project filters
      if (filters.project && filters.project.length > 0) {
        filters.project.forEach((project) => {
          const itemId = getItemId(project);
          if (itemId) {
            queryString += `&project=${encodeURIComponent(itemId)}`;
          }
        });
      }

      // معالجة Developer filters
      if (filters.developer && filters.developer.length > 0) {
        filters.developer.forEach((developer) => {
          const itemId = getItemId(developer);
          if (itemId) {
            queryString += `&developer=${encodeURIComponent(itemId)}`;
          }
        });
      }

      // معالجة Channel filters
      if (filters.chanel && filters.chanel.length > 0) {
        filters.chanel.forEach((chanel) => {
          const itemId = getItemId(chanel);
          if (itemId) {
            queryString += `&channel=${encodeURIComponent(itemId)}`;
          }
        });
      }

      // معالجة Campaign filters
      if (filters.campaign && filters.campaign.length > 0) {
        filters.campaign.forEach((campaign) => {
          const itemId = getItemId(campaign);
          if (itemId) {
            queryString += `&campaign=${encodeURIComponent(itemId)}`;
          }
        });
      }

      // ✅ معالجة Sales filters
      if (filters.sales && filters.sales.length > 0) {
        filters.sales.forEach((sale) => {
          const itemId = getItemId(sale);
          if (itemId) {
            queryString += `&sales=${encodeURIComponent(itemId)}`;
          }
        });
      }

      // معالجة Creation Date
      if (filters.createdAt) {
        if (filters.createdAt.from) {
          queryString += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
        }
        if (filters.createdAt.to) {
          queryString += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
        }
      }

      // 🔥 معالجة Stage Date Range
      if (filters.stagedateupdated) {
        if (filters.stagedateupdated.from) {
          queryString += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
        }
        if (filters.stagedateupdated.to) {
          queryString += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
        }
      }

      console.log('🔗 Final Query String:', queryString);
      return queryString;
    },
    [currentPage, rowsPerPage, searchword, appliedFilters],
  );

  // 🔥 دالة جلب البيانات المعدلة
  const fetchLeads = useCallback(
    async (page = null, customQueryString = null) => {
      setLoading(true);
      setError(null);
      try {
        // استخدم رقم الصفحة المطلوب
        const pageToUse = page !== null ? page : currentPage;

        // 🔥 استخدم buildQueryString أو customQueryString
        const queryString = customQueryString || buildQueryString(pageToUse);

        console.log('🚀 START fetchLeads');
        console.log('📅 Requested page:', pageToUse);
        console.log('📏 Requested limit:', rowsPerPage);
        console.log('🔍 Search query:', searchword);
        console.log('🎯 Applied filters:', appliedFilters);
        console.log('🔗 Query string:', queryString);

        // 🔥 استدع الـ action بالـ query string الصحيح
        const result = await dispatch(LeadsDoneDealOnly_Action(queryString));

        // تحقق من الـ response
        console.log('📦 API Response:', result);

        if (result?.error) {
          setError(result.error.message || 'Failed to fetch leads');
        }

        // 🔥 تحديث حالة الصفحة بناءً على استجابة الـ API
        if (result?.payload?.data?.pagination?.currentPage) {
          const serverPage = result.payload.data.pagination.currentPage - 1; // تحويل لـ zero-based
          console.log('🔄 Server returned page:', serverPage);
          if (serverPage !== currentPage) {
            setCurrentPage(serverPage);
          }
        }
      } catch (error) {
        console.error('❌ Error fetching leads:', error);
        setError(error.message || 'An error occurred while fetching data');
      } finally {
        setLoading(false);
      }
    },
    [dispatch, buildQueryString, currentPage, rowsPerPage, searchword, appliedFilters],
  );

  // Initial fetch
  useEffect(() => {
    fetchLeads();
  }, []);

  // Fetch when filters or pagination changes
  useEffect(() => {
    if (!localSearchMode) {
      fetchLeads();
    }
  }, [currentPage, rowsPerPage, searchword, appliedFilters]);

  // Fetch all other data
  useEffect(() => {
    const getAllData = async () => {
      try {
        await Promise.all([
          dispatch(GetallProjectsdata()),
          dispatch(GetAllchannalData()),
          dispatch(GetDevelopersData()),
          dispatch(Get_All_Sales_Action()),
        ]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    getAllData();
  }, [dispatch]);

  // Redux selectors
  const resleads = useSelector((state) => state.AllAcountant_Reducer?.LeadsForAccountant);
  console.log('Redux leads data:', resleads);

  // تأكد من أن البيانات موجودة وصحيحة
  const Leadsarray = resleads?.data || [];
  console.log('Leadsarray:', Leadsarray.length, 'items');

  // Calculate active filters count
  useEffect(() => {
    let count = 0;
    if (appliedFilters.stage.length > 0) count++;
    if (appliedFilters.project.length > 0) count++;
    if (appliedFilters.developer.length > 0) count++;
    if (appliedFilters.chanel.length > 0) count++;
    if (appliedFilters.campaign.length > 0) count++;
    if (appliedFilters.createdAt.from) count++;
    if (appliedFilters.sales.length > 0) count++; // أضف هذا

    if (appliedFilters.createdAt.to) count++;
    if (appliedFilters.stagedateupdated.from) count++;
    if (appliedFilters.stagedateupdated.to) count++;
    if (searchword.trim()) count++;
    setActiveFilters(count);
  }, [appliedFilters, searchword]);

  // Search function
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchword(value);
    localStorage.setItem('searchAccountantuserstorage', value);
    setCurrentPage(0); // Reset to first page on new search
  };

  // Handle page change - server side
  const handleChangePage = async (event, newPage) => {
    setCurrentPage(newPage);
    await fetchLeads(newPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleChangeRowsPerPage = async (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log(`🔄 Changing rows per page from ${rowsPerPage} to ${newRowsPerPage}`);

    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0); // العودة للصفحة الأولى عند تغيير الـ limit

    // جلب البيانات مع الـ limit الجديد
    setTimeout(() => {
      fetchLeads(0);
    }, 100);
  };

  // Navigation buttons handlers
  const handleFirstPage = async () => {
    setCurrentPage(0);
    await fetchLeads(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePrevPage = async () => {
    if (currentPage > 0) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      await fetchLeads(newPage);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNextPage = async () => {
    const totalPages = resleads?.pagination?.NumberOfPages || 1;
    if (currentPage < totalPages - 1) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      await fetchLeads(newPage);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleLastPage = async () => {
    const totalPages = resleads?.pagination?.NumberOfPages || 1;
    const lastPage = Math.max(0, totalPages - 1);
    setCurrentPage(lastPage);
    await fetchLeads(lastPage);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // 🔥 Handle filter apply من الفلتر الجديد
  const handleApplyFilters = (filters, queryString) => {
    console.log('🎯 Applying filters from modal:', filters);
    setAppliedFilters(filters);
    setCurrentPage(0); // Reset to first page

    // إذا كان هناك query string جاهز من الفلتر، استخدمه
    if (queryString) {
      console.log('🔗 Using query string from modal:', queryString);
      fetchLeads(0, queryString);
    } else {
      // وإلا بني query string جديد
      const newQueryString = buildQueryString(0, filters);
      fetchLeads(0, newQueryString);
    }
  };

  // Clear all filters
  const clearAllFilters = () => {
    setAppliedFilters({
      stage: [],
      project: [],
      developer: [],
      chanel: [],
      campaign: [],
      sales: [], // أضف هذا

      createdAt: { from: null, to: null },
      stagedateupdated: { from: null, to: null },
    });
    setSearchword('');
    localStorage.removeItem('searchAccountantuserstorage');
    setCurrentPage(0);
    setLocalSearchMode(false);
  };

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };

  // Get total values from API response
  const totalLeads = resleads?.count || 0;
  const totalPages =
    resleads?.pagination?.NumberOfPages || Math.ceil(totalLeads / rowsPerPage) || 1;
  const doneDealCount = resleads?.doneDealCount || 0;
  const eoiCount = resleads?.eoiCount || 0;

  // Calculate totals from displayed data
  const displayedLeadsCount = Leadsarray.length;

  const totalUnitPrice = Leadsarray.reduce((sum, lead) => {
    const price = parseFloat(lead.unit_price);
    return sum + (isNaN(price) ? 0 : price);
  }, 0);

  const totalCommission = Leadsarray.reduce((sum, lead) => {
    const commission = parseFloat(lead.commissionmoney);
    return sum + (isNaN(commission) ? 0 : commission);
  }, 0);

  // Handle local search toggle
  const toggleLocalSearch = () => {
    setLocalSearchMode(!localSearchMode);
    if (!localSearchMode) {
      setCurrentPage(0);
    }
  };

  // Filter leads locally if in local search mode
  const getFilteredLeads = () => {
    if (!localSearchMode || !searchword.trim()) {
      return Leadsarray;
    }

    const searchTerm = searchword.toLowerCase().trim();
    return Leadsarray.filter((lead) => {
      if (!lead) return false;

      return (
        (lead.name && lead.name.toLowerCase().includes(searchTerm)) ||
        (lead.email && lead.email.toLowerCase().includes(searchTerm)) ||
        (lead.phone && lead.phone.includes(searchTerm))
      );
    });
  };

  const finalLeads = getFilteredLeads();
  const finalDisplayCount = finalLeads.length;
  const startIndex = 0; // Server pagination, so always start from 0
  const endIndex = Math.min(rowsPerPage, finalLeads.length);
  const finalPaginatedLeads = localSearchMode ? finalLeads.slice(startIndex, endIndex) : Leadsarray;

  // Custom Pagination Component
  const CustomPagination = () => {
    // احصل على معلومات الـ pagination من الـ response
    const pagination = resleads?.pagination;
    const totalPages =
      pagination?.NumberOfPages || Math.ceil((resleads?.count || 0) / rowsPerPage) || 1;

    const isFirstPage = currentPage === 0;
    const isLastPage = currentPage >= totalPages - 1;

    // احسب هل هناك صفحات سابقة/تالية بناءً على بيانات الـ backend
    const hasPrevPage = pagination?.hasPrevPage || !isFirstPage;
    const hasNextPage = pagination?.hasNextPage || !isLastPage;

    const handleFirstPage = async () => {
      if (currentPage !== 0) {
        setCurrentPage(0);
        await fetchLeads(0);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    const handlePrevPage = async () => {
      if (hasPrevPage && currentPage > 0) {
        const newPage = currentPage - 1;
        setCurrentPage(newPage);
        await fetchLeads(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    const handleNextPage = async () => {
      if (hasNextPage && currentPage < totalPages - 1) {
        const newPage = currentPage + 1;
        setCurrentPage(newPage);
        await fetchLeads(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    const handleLastPage = async () => {
      const lastPage = Math.max(0, totalPages - 1);
      if (currentPage !== lastPage) {
        setCurrentPage(lastPage);
        await fetchLeads(lastPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          p: 2,
          borderTop: 1,
          borderColor: 'divider',
          backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
        }}
      >
        {/* First Page Button */}
        <Tooltip title="First Page">
          <span>
            <IconButton
              onClick={handleFirstPage}
              disabled={isFirstPage || loading}
              size="small"
              sx={{
                color: isFirstPage ? 'text.disabled' : 'primary.main',
                '&:hover:not(:disabled)': {
                  backgroundColor: 'primary.light',
                  color: 'white',
                },
              }}
            >
              <FirstPageIcon />
            </IconButton>
          </span>
        </Tooltip>

        {/* Previous Page Button */}
        <Tooltip title="Previous Page">
          <span>
            <IconButton
              onClick={handlePrevPage}
              disabled={!hasPrevPage || loading}
              size="small"
              sx={{
                color: !hasPrevPage ? 'text.disabled' : 'primary.main',
                '&:hover:not(:disabled)': {
                  backgroundColor: 'primary.light',
                  color: 'white',
                },
              }}
            >
              <ArrowBackIosIcon />
            </IconButton>
          </span>
        </Tooltip>

        {/* Page Info */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mx: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'medium',
              color: 'text.primary',
            }}
          >
            Page
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'bold',
              color: 'primary.main',
              minWidth: '30px',
              textAlign: 'center',
            }}
          >
            {currentPage + 1}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            of
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'bold',
              color: 'text.secondary',
              minWidth: '30px',
              textAlign: 'center',
            }}
          >
            {totalPages}
          </Typography>
        </Box>

        {/* Next Page Button */}
        <Tooltip title="Next Page">
          <span>
            <IconButton
              onClick={handleNextPage}
              disabled={!hasNextPage || loading}
              size="small"
              sx={{
                color: !hasNextPage ? 'text.disabled' : 'primary.main',
                '&:hover:not(:disabled)': {
                  backgroundColor: 'primary.light',
                  color: 'white',
                },
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </span>
        </Tooltip>

        {/* Last Page Button */}
        <Tooltip title="Last Page">
          <span>
            <IconButton
              onClick={handleLastPage}
              disabled={isLastPage || loading}
              size="small"
              sx={{
                color: isLastPage ? 'text.disabled' : 'primary.main',
                '&:hover:not(:disabled)': {
                  backgroundColor: 'primary.light',
                  color: 'white',
                },
              }}
            >
              <LastPageIcon />
            </IconButton>
          </span>
        </Tooltip>

        {/* Total Records */}
        <Typography
          variant="body2"
          sx={{
            ml: 3,
            color: 'text.secondary',
            fontSize: '0.875rem',
          }}
        >
          {totalLeads.toLocaleString()} total records
        </Typography>

        {/* Rows Per Page Selector */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Show:
          </Typography>
          <Select
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
            size="small"
            sx={{
              minWidth: 80,
              '& .MuiSelect-select': {
                py: 0.5,
                fontSize: '0.875rem',
              },
            }}
            disabled={loading}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={150}>150</MenuItem>
            <MenuItem value={200}>200</MenuItem>
            <MenuItem value={250}>250</MenuItem>
            <MenuItem value={300}>300</MenuItem>
          </Select>
        </Box>
      </Box>
    );
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3, px: { xs: 2, sm: 3 } }} className="startpage">
      {/* Error Snackbar */}
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" onClose={() => setError(null)} icon={<WarningIcon />}>
          {error}
        </Alert>
      </Snackbar>

      {/* Header */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome 👋{' '}
          <span style={{ color: theme.palette.primary.main, fontWeight: 600 }}>
            {userlogin?.data?.name || 'User'}
          </span>
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Accountant Dashboard - View and manage all completed deals
        </Typography>
      </Box>

      {/* Search and Filter Bar */}
      <Paper
        elevation={1}
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 2,
          backgroundColor: mode === 'dark' ? 'background.paper' : '#f8f9fa',
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={8}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search by name, email, or phone..."
              value={searchword}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {searchword && (
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSearchword('');
                          localStorage.removeItem('searchAccountantuserstorage');
                          setCurrentPage(0);
                        }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    )}
                    <Tooltip
                      title={localSearchMode ? 'Switch to server search' : 'Switch to local search'}
                    >
                      <IconButton
                        size="small"
                        onClick={toggleLocalSearch}
                        color={localSearchMode ? 'primary' : 'default'}
                      >
                        <SearchIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
                sx: { borderRadius: 2 },
              }}
            />
            {localSearchMode && (
              <Typography variant="caption" color="info.main" sx={{ mt: 1, display: 'block' }}>
                ⚡ Local search mode enabled (fast, but only searches displayed data)
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => setFilterModalOpen(true)}
                sx={{ borderRadius: 2 }}
              >
                Filters
                {activeFilters > 0 && (
                  <Badge badgeContent={activeFilters} color="error" sx={{ ml: 1 }} />
                )}
              </Button>

              {activeFilters > 0 && (
                <Button
                  variant="outlined"
                  color="error"
                  startIcon={<ClearIcon />}
                  onClick={clearAllFilters}
                  sx={{ borderRadius: 2 }}
                >
                  Clear
                </Button>
              )}

              <Button
                variant="contained"
                startIcon={<RefreshIcon />}
                onClick={() => fetchLeads()}
                sx={{ borderRadius: 2 }}
                disabled={loading}
              >
                {loading ? 'Loading...' : 'Refresh'}
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Active Filters Display */}
        {/* Active Filters Display */}
        {activeFilters > 0 && (
          <Fade in={activeFilters > 0}>
            <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {searchword && (
                <Chip
                  label={`Search: "${searchword}"`}
                  onDelete={() => {
                    setSearchword('');
                    localStorage.removeItem('searchAccountantuserstorage');
                    setCurrentPage(0);
                  }}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              )}

              {localSearchMode && (
                <Chip label="Local Search" size="small" color="info" onDelete={toggleLocalSearch} />
              )}

              {appliedFilters.stage &&
                appliedFilters.stage.map((stage, index) => (
                  <Chip
                    key={stage._id || index}
                    label={`Stage: ${stage.name || 'Unknown'}`}
                    size="small"
                    onDelete={() => {
                      setAppliedFilters((prev) => ({
                        ...prev,
                        stage: prev.stage.filter((s) => s._id !== stage._id),
                      }));
                      setCurrentPage(0);
                    }}
                  />
                ))}

              {appliedFilters.project &&
                appliedFilters.project.map((project, index) => (
                  <Chip
                    key={project._id || index}
                    label={`Project: ${project.name || 'Unknown'}`}
                    size="small"
                    onDelete={() => {
                      setAppliedFilters((prev) => ({
                        ...prev,
                        project: prev.project.filter((p) => p._id !== project._id),
                      }));
                      setCurrentPage(0);
                    }}
                  />
                ))}

              {appliedFilters.developer &&
                appliedFilters.developer.map((developer, index) => (
                  <Chip
                    key={developer._id || index}
                    label={`Developer: ${developer.name || 'Unknown'}`}
                    size="small"
                    onDelete={() => {
                      setAppliedFilters((prev) => ({
                        ...prev,
                        developer: prev.developer.filter((d) => d._id !== developer._id),
                      }));
                      setCurrentPage(0);
                    }}
                  />
                ))}

              {appliedFilters.chanel &&
                appliedFilters.chanel.map((channel, index) => (
                  <Chip
                    key={channel._id || index}
                    label={`Channel: ${channel.name || 'Unknown'}`}
                    size="small"
                    onDelete={() => {
                      setAppliedFilters((prev) => ({
                        ...prev,
                        chanel: prev.chanel.filter((c) => c._id !== channel._id),
                      }));
                      setCurrentPage(0);
                    }}
                  />
                ))}

              {appliedFilters.campaign &&
                appliedFilters.campaign.map((campaign, index) => (
                  <Chip
                    key={campaign._id || index}
                    label={`Campaign: ${campaign.CampainName || 'Unknown'}`}
                    size="small"
                    onDelete={() => {
                      setAppliedFilters((prev) => ({
                        ...prev,
                        campaign: prev.campaign.filter((c) => c._id !== campaign._id),
                      }));
                      setCurrentPage(0);
                    }}
                  />
                ))}

              {/* ✅ أضف فلتر Sales هنا */}
              {appliedFilters.sales &&
                appliedFilters.sales.map((sale, index) => (
                  <Chip
                    key={sale._id || index}
                    label={`Sales: ${sale.name || 'Unknown'}`}
                    size="small"
                    onDelete={() => {
                      setAppliedFilters((prev) => ({
                        ...prev,
                        sales: prev.sales.filter((s) => s._id !== sale._id),
                      }));
                      setCurrentPage(0);
                    }}
                  />
                ))}

              {(appliedFilters.createdAt?.from || appliedFilters.createdAt?.to) && (
                <Chip
                  label={`Date: ${appliedFilters.createdAt.from ? moment(appliedFilters.createdAt.from).format('DD/MM/YYYY') : 'Any'} - ${appliedFilters.createdAt.to ? moment(appliedFilters.createdAt.to).format('DD/MM/YYYY') : 'Any'}`}
                  size="small"
                  onDelete={() => {
                    setAppliedFilters((prev) => ({
                      ...prev,
                      createdAt: { from: null, to: null },
                    }));
                    setCurrentPage(0);
                  }}
                />
              )}

              {(appliedFilters.stagedateupdated?.from || appliedFilters.stagedateupdated?.to) && (
                <Chip
                  label={`Stage Date: ${appliedFilters.stagedateupdated.from ? moment(appliedFilters.stagedateupdated.from).format('DD/MM/YYYY') : 'Any'} - ${appliedFilters.stagedateupdated.to ? moment(appliedFilters.stagedateupdated.to).format('DD/MM/YYYY') : 'Any'}`}
                  size="small"
                  onDelete={() => {
                    setAppliedFilters((prev) => ({
                      ...prev,
                      stagedateupdated: { from: null, to: null },
                    }));
                    setCurrentPage(0);
                  }}
                />
              )}
            </Box>
          </Fade>
        )}

        {/* Debug Info */}
        <Box
          sx={{
            mt: 2,
            p: 1,
            bgcolor: mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.05)',
            borderRadius: 1,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            Page: {currentPage + 1} | Total Pages: {totalPages} | Total Leads: {totalLeads} |
            Displayed: {displayedLeadsCount}
          </Typography>
        </Box>
      </Paper>

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
            <CardContent sx={{ textAlign: 'center', p: 3 }}>
              <Avatar sx={{ bgcolor: 'primary.light', mb: 2, mx: 'auto' }}>
                <PeopleIcon />
              </Avatar>
              <Typography variant="h4" color="primary" fontWeight="bold">
                {totalLeads.toLocaleString()}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Leads
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Page: {displayedLeadsCount}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
            <CardContent sx={{ textAlign: 'center', p: 3 }}>
              <Avatar sx={{ bgcolor: 'success.light', mb: 2, mx: 'auto' }}>
                <AttachMoneyIcon />
              </Avatar>
              <Typography variant="h4" color="success.main" fontWeight="bold">
                {formatCurrency(totalUnitPrice)} AED
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Value
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Page Total
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
            <CardContent sx={{ textAlign: 'center', p: 3 }}>
              <Avatar sx={{ bgcolor: 'warning.light', mb: 2, mx: 'auto' }}>
                <TrendingUpIcon />
              </Avatar>
              <Typography variant="h4" color="warning.main" fontWeight="bold">
                {formatCurrency(totalCommission)} AED
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Commission
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Done Deals: {doneDealCount}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
            <CardContent sx={{ textAlign: 'center', p: 3 }}>
              <Avatar sx={{ bgcolor: 'info.light', mb: 2, mx: 'auto' }}>
                <AssignmentTurnedInIcon />
              </Avatar>
              <Typography variant="h4" color="info.main" fontWeight="bold">
                {eoiCount}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                EOI Count
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Expression of Interest
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Main Table Section */}
      <Paper elevation={3} sx={{ borderRadius: 3, overflow: 'hidden' }}>
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Typography variant="h6" component="h2">
                Done Deals
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {totalLeads.toLocaleString()} total records • {displayedLeadsCount} on this page
                {localSearchMode && ' • ⚡ Local Search'}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="text.secondary">
                Page {currentPage + 1} of {totalPages}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {loading ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              p: 8,
              minHeight: 300,
            }}
          >
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Loading leads data...
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Please wait while we fetch your data
            </Typography>
          </Box>
        ) : displayedLeadsCount === 0 ? (
          <Box sx={{ textAlign: 'center', p: 8, minHeight: 300 }}>
            <SearchIcon sx={{ fontSize: 60, color: 'text.disabled', mb: 2, opacity: 0.5 }} />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No records found
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mb: 3, maxWidth: 400, mx: 'auto' }}
            >
              {totalLeads === 0
                ? 'There are no done deals in the system yet.'
                : 'Try adjusting your filters or search criteria'}
            </Typography>
            {activeFilters > 0 && (
              <Button variant="outlined" onClick={clearAllFilters} startIcon={<ClearIcon />}>
                Clear All Filters
              </Button>
            )}
            {totalLeads > 0 && (
              <Button
                variant="contained"
                onClick={() => fetchLeads()}
                sx={{ ml: 1 }}
                startIcon={<RefreshIcon />}
              >
                Refresh Data
              </Button>
            )}
          </Box>
        ) : (
          <>
            <TableContainer sx={{ maxHeight: '60vh' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: mode === 'dark' ? '#2c3e50' : '#f5f5f5',
                      }}
                    >
                      Actions
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: mode === 'dark' ? '#2c3e50' : '#f5f5f5',
                      }}
                    >
                      Lead Details
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: mode === 'dark' ? '#2c3e50' : '#f5f5f5',
                      }}
                    >
                      Stage & Team
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: mode === 'dark' ? '#2c3e50' : '#f5f5f5',
                      }}
                    >
                      Project Info
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: mode === 'dark' ? '#2c3e50' : '#f5f5f5',
                      }}
                    >
                      Financials
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: mode === 'dark' ? '#2c3e50' : '#f5f5f5',
                      }}
                    >
                      Dates & Added By
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {finalPaginatedLeads.map((lead, index) => (
                    <TableRow
                      key={lead._id || index}
                      hover
                      sx={{
                        '&:nth-of-type(odd)': {
                          backgroundColor:
                            mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.02)',
                        },
                        '&:hover': {
                          backgroundColor:
                            mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
                        },
                      }}
                    >
                      {/* Actions */}
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <Tooltip
                            title={lead?.review === false ? 'Review Commission' : 'View Commission'}
                          >
                            <Link
                              to={`/LeadReviewCommission/${lead._id}`}
                              style={{ textDecoration: 'none' }}
                            >
                              <Button
                                variant={lead?.review === false ? 'contained' : 'outlined'}
                                color="primary"
                                size="small"
                                fullWidth
                                startIcon={<VisibilityIcon />}
                              >
                                {lead?.review === false ? 'Review' : 'View'}
                              </Button>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Commission Schedule">
                            <Link
                              to={`/CommissionSchedual/${lead._id}`}
                              style={{ textDecoration: 'none' }}
                            >
                              <Button
                                variant="outlined"
                                color="warning"
                                size="small"
                                fullWidth
                                startIcon={<AccessAlarmIcon />}
                              >
                                Schedule
                              </Button>
                            </Link>
                          </Tooltip>
                        </Box>
                      </TableCell>

                      {/* Lead Details */}
                      <TableCell>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {lead.name || 'N/A'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          ID: {lead._id?.substring(0, 10)}...
                        </Typography>
                        <Divider sx={{ my: 1 }} />
                        <Box>
                          <Typography variant="body2">
                            <strong>Email:</strong> {lead.email || 'N/A'}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Phone:</strong> {lead.phone || 'N/A'}
                          </Typography>
                          {lead.whatsappnumber && (
                            <Typography variant="body2">
                              <strong>WhatsApp:</strong> {lead.whatsappnumber}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>

                      {/* Stage & Team */}
                      <TableCell>
                        <Chip
                          label={lead.stage?.name || 'Done Deal'}
                          color="success"
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="body2">
                            <strong>Marketer:</strong> {lead.chanel?.name || 'N/A'}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Sales:</strong> {lead.sales?.name || 'N/A'}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Team Leader:</strong> {lead.sales?.teamleader?.name || 'N/A'}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Manager:</strong> {lead.sales?.Manager?.name || 'N/A'}
                          </Typography>
                          <Typography variant="body2">
                            <strong>Done Deal Date:</strong>
                            {lead.stagedateupdated
                              ? moment(lead.stagedateupdated)
                                  .tz('Asia/Dubai')
                                  .format('DD/MM/YYYY hh:mm A')
                              : 'N/A'}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Project Info */}
                      <TableCell>
                        <Typography variant="body2">
                          <strong>Developer:</strong> {lead.project?.developer?.name || 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Project:</strong> {lead.project?.name || 'N/A'}
                        </Typography>
                        <Typography variant="body2">
                          <strong>City:</strong> {lead.project?.city?.name || 'N/A'}
                        </Typography>
                        {lead.unitnumber && (
                          <Typography variant="body2">
                            <strong>Unit:</strong> {lead.unitnumber}
                          </Typography>
                        )}
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          <strong>Campaign:</strong> {lead.campaign?.CampainName || 'Default'}
                        </Typography>
                      </TableCell>

                      {/* Financials */}
                      <TableCell>
                        <Typography variant="h6" color="primary" fontWeight="bold">
                          {formatCurrency(lead.unit_price)} AED
                        </Typography>
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="body2">
                            <strong>Budget:</strong> {lead.budget || 0}K
                          </Typography>
                          <Typography variant="body2">
                            <strong>Commission:</strong> {formatCurrency(lead.commissionmoney)} AED
                          </Typography>
                          <Typography variant="body2">
                            <strong>Ratio:</strong> {lead.commissionratio || 0}%
                          </Typography>
                          {lead.cashbackmoney > 0 && (
                            <Typography variant="body2">
                              <strong>Cashback:</strong> {formatCurrency(lead.cashbackmoney)} AED
                            </Typography>
                          )}
                        </Box>
                      </TableCell>

                      {/* Dates & Added By */}
                      <TableCell>
                        <Typography variant="body2">
                          <strong>Created:</strong>
                        </Typography>
                        <Typography variant="body2">
                          {lead.createdAt
                            ? moment(lead.createdAt).tz('Asia/Dubai').format('DD/MM/YYYY')
                            : 'N/A'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {lead.createdAt
                            ? moment(lead.createdAt).tz('Asia/Dubai').format('hh:mm A')
                            : ''}
                        </Typography>

                        {lead.lastComment && (
                          <>
                            <Divider sx={{ my: 1 }} />
                            <Typography variant="body2">
                              <strong>Last Comment:</strong>
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ fontStyle: 'italic' }}
                            >
                              {lead.lastComment.firstcomment || 'No comment'}
                            </Typography>
                          </>
                        )}

                        <Divider sx={{ my: 1 }} />
                        <Typography variant="body2">
                          <strong>Added By:</strong>
                        </Typography>
                        <Typography variant="body2">{lead.addby?.name || 'N/A'}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {lead.addby?.email || ''}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Custom Pagination */}
            <CustomPagination />
          </>
        )}
      </Paper>

      {/* Footer */}
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary">
          HomeWalkers CRM • Accountant Dashboard • Data as of{' '}
          {moment().format('DD MMMM YYYY, hh:mm A')}
          {localSearchMode && ' • ⚡ Local Search Mode'}
        </Typography>
      </Box>

      {/* Filter Modal */}
      <DoneDealQuickFilterModal
        open={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
        onApplyFilters={handleApplyFilters}
        initialFilters={appliedFilters}
      />
    </Container>
  );
};
